import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import FileDownload from 'js-file-download';

import { downloadPersonalData } from '../../redux/modules/activity-log/activity-log-middleware';

import { messages } from './DataExportPanel.i18n';


class DataExportPanel extends React.Component {
  downloadPersonalData = () => {
    const { dispatch, patient } = this.props;
    dispatch(downloadPersonalData(patient.patientId, (fileData) => FileDownload(fileData,
      `${patient.firstName}${patient.lastName}_${moment().format('YYYYMMDD')}_PersonalData.xml`)));
  }

  render = () => (
    <div className="settings-section row" id="download-panel-body">
      <h4 id="download-panel-content" className="mt-2" tabIndex="0" role="form">
        <span className="title"><FormattedMessage { ...messages.panel.title } /></span>
      </h4>
      <p tabIndex="0"><FormattedMessage { ...messages.panel.subTitles.primary } /></p>
      <p tabIndex="0"><FormattedMessage { ...messages.panel.subTitles.secondary } /></p>
      <div className="row row-cols-auto">
        <div className="col">
          <button
            type="button"
            data-qa-item="download-personal-data"
            onClick={this.downloadPersonalData}
            className="btn btn-primary"
          >
          <FormattedMessage { ...messages.panel.buttons.download } />
          </button>
        </div>
      </div>
    </div>);
}

DataExportPanel.propTypes = {
  dispatch: PropTypes.func,
  patient: PropTypes.object,
};

const mapStateToProps = (state) => (
  {
    patient: state.profile.patient,
  }
);

export default connect(mapStateToProps)(DataExportPanel);
